import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab6bc4e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lose__page" }
const _hoisted_2 = { class: "lose__page-inner" }
const _hoisted_3 = {
  key: 0,
  class: "lose__page-header"
}
const _hoisted_4 = {
  key: 1,
  class: "lose__page-header"
}
const _hoisted_5 = {
  key: 2,
  class: "lose__page-text"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://tprg.ru/bMLg",
  target: "_blank",
  class: "link-doc conf-link"
}, "Оставьте контакты,", -1))
const _hoisted_8 = { class: "final__menu" }
const _hoisted_9 = {
  key: 0,
  href: "#",
  class: "restart__link",
  target: "_blank"
}
const _hoisted_10 = {
  key: 1,
  class: "about-selectel-stand"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tp_button = _resolveComponent("tp-button")!
  const _component_tp_share = _resolveComponent("tp-share")!
  const _component_selectel = _resolveComponent("selectel")!
  const _component_tp_box = _resolveComponent("tp-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tp_box, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isConf==='')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Не сложилось :( Попробуете ещё раз?"))
            : _createCommentVNode("", true),
          (_ctx.isConf==='conf1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Не сложилось :("))
            : _createCommentVNode("", true),
          (_ctx.isConf==='conf1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createTextVNode(" Зато вы можете выиграть Тирекса! "),
                _hoisted_6,
                _hoisted_7,
                _createTextVNode(" чтобы поучаствовать в розыгрыше. ")
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_tp_button, {
            class: "restart__button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.restart()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Сыграть ещё раз")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_tp_share),
          (_ctx.isConf==='')
            ? (_openBlock(), _createElementBlock("a", _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.isConf==='conf1')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Подробности розыгрыша уточняйте на стенде Selectel "))
            : _createCommentVNode("", true),
          _createVNode(_component_selectel, { class: "lose__page-selectel-logo" })
        ]),
        _createElementVNode("div", {
          class: "blur__background lose-blur__background",
          style: _normalizeStyle(`background: url(${require('@/assets/red-blur.svg')}) no-repeat center`)
        }, null, 4)
      ]),
      _: 1
    })
  ]))
}